module.exports = __webpack_public_path__ + "img/thumbnail_MalayanTapir_j_normal.b5f9a512.png";